module.exports = __webpack_public_path__ + "img/CellCycle-CRC_CRLM.75e61a4d.png";